import { createGetAPI, createGetAllAPI } from '@cuemath/rest-api';
import { stringify } from 'query-string';
import { BASE_URL } from 'constants/api';

const QUEUE_URL = `${BASE_URL}/chatbot/queue-dashboard`;

// The dashboard read. Tiles and panes arrive together from one snapshot, so
// they can never disagree — splitting this into separate calls would let a
// tile read 39 above a list of 38.
// No `invalidate` on either of these: `createGetAPI`'s `get` has no cache
// check — it writes PENDING and fetches unconditionally — so invalidating
// first only set a `isStale` flag nothing reads.
const { useGet: useGetQueueDashboard } = createGetAPI({
  getURL: (_, query) => `${QUEUE_URL}/?${stringify(query || {})}`,
});

// The rows behind one tile. Deliberately NOT the agent inbox endpoint: that
// one ANDs its user_type and source filters so it cannot express the board's
// scope, and it silently ignores a date window — pointing the drill-down at
// it gave a chip reading 10 a list of 64.
const { useGetAll: useGetQueueTickets } = createGetAllAPI({
  getURL: query => `${QUEUE_URL}/tickets/?${stringify(query || {})}`,
});


export { useGetQueueDashboard, useGetQueueTickets };
